var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sms-text-box-editor-wrapper"},[_c('label',{staticClass:"floating-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{ref:"editor",staticClass:"sms-text-box-editor",class:_vm.error ? 'danger' : '',attrs:{"contenteditable":"true"},on:{"input":_vm.updateModel,"keydown":_vm.handleKeydown,"blur":_vm.handleBlur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }